import React from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import ResourceFormDialog from './ResourceFormDialog';
import { CREATE_TAG, UPDATE_TAG } from '../graphql/mutations';
import { TAGS_QUERY } from '../graphql/queries';

const TAG_QUERY = gql`
  query Tag($id: ID!) {
    tag(id: $id) {
      id
      name
    }
  }
`;

const FORM_FIELDS = [{ key: 'name', label: 'Name', type: 'text', required: true }];

/**
 * Create/edit tag dialog (replaces the former /tags/new and
 * /tags/:id/edit form pages).
 *
 * @param {boolean} open
 * @param {{id: number}|null} tag — record to edit, or null to create
 * @param {Function} onClose
 */
export default function TagFormDialog({ open, tag, onClose }) {
  const id = tag?.id ?? null;
  const { data, loading: resourceLoading } = useQuery(TAG_QUERY, {
    variables: { id },
    skip: !open || !id
  });

  const [updateTag, { loading: updateLoading }] = useMutation(UPDATE_TAG, {
    refetchQueries: [{ query: TAGS_QUERY }],
    awaitRefetchQueries: true
  });
  const [createTag, { loading: createLoading }] = useMutation(CREATE_TAG, {
    refetchQueries: [{ query: TAGS_QUERY }],
    awaitRefetchQueries: true
  });

  const handleSubmit = async (formState) => {
    try {
      if (id) {
        await updateTag({ variables: { input: { id, name: formState.name } } });
      } else {
        await createTag({ variables: { input: { name: formState.name } } });
      }
      onClose();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <ResourceFormDialog
      open={open}
      title={id ? 'Edit Tag' : 'New Tag'}
      resource={data?.tag ?? null}
      fields={FORM_FIELDS}
      resourceLoading={Boolean(id) && resourceLoading}
      loading={updateLoading || createLoading}
      submitLabel={id ? 'Update Tag' : 'Add Tag'}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}
